import { MinimalCertificateDisplayType } from '../interfaces/interface.minimal-certificate-offer';
import EventBus from '../services/service.eventBus';
import { updateKbycAcceptOffer } from '../services/service.offer';
import { state as kbycMinimalCertificateState } from '../store/store.kelley-buys-your-car-minimal-certificate';
import { state as kbycOfferState } from '../store/store.kelley-buys-your-car-offer';
import { state as pageParamsState } from '../store/store.page-params';
import { trackCertificateViewYourOffer } from '../tracking/tracking.unified-disposal';
import { KBYC_DEALER, isUnderReview } from '../utils/utils.offer';

export const onAcceptOffer = () => {
  kbycOfferState.isSubmitting = true;
  updateKbycAcceptOffer(kbycOfferState.offerId)
    .then(() => onUpdateKbycAcceptOfferSuccess())
    .catch((error) => onUpdateKbycAcceptOfferFailure(error))
    .finally(() => onUpdateKbycAcceptOfferComplete());
};

export const shouldOpenAcceptModal = () => !kbycOfferState.isDisposalAccepted && new URLSearchParams(window.location.search).get('intentToAccept') === 'true';

const onUpdateKbycAcceptOfferSuccess = () => {
  kbycOfferState.isSubmitting = false;
  kbycOfferState.isDisposalAccepted = true;
  EventBus.publish('UpdateKbycAcceptOfferSuccess', {});
};
const onUpdateKbycAcceptOfferFailure = (error: object) => {
  EventBus.publish('UpdateKbycAcceptOfferFailure', error);
};
const onUpdateKbycAcceptOfferComplete = () => {
  kbycOfferState.isSubmitting = false;
  EventBus.publish('UpdateKbycAcceptOfferComplete', {});
};

const onMinimalCertificateSet = ({ amount, expirationDate, isExpired, offerId, status, prospect, offerCode, ineligibleReasons, kbycOffset, displayType }) => {
  kbycMinimalCertificateState.amount = amount + kbycOffset;
  kbycMinimalCertificateState.offerId = offerId;
  kbycMinimalCertificateState.expirationDate = new Date(expirationDate).toLocaleDateString();
  kbycMinimalCertificateState.isExpired = isExpired;
  kbycMinimalCertificateState.status = status;
  kbycMinimalCertificateState.isOfferUnderReview = isUnderReview(status);
  kbycMinimalCertificateState.isIneligibleOffer = status === 'INELIGIBLE';
  kbycMinimalCertificateState.isFurtherReviewNeeded = status === 'FR';
  kbycMinimalCertificateState.isInspectionNeeded = status === 'INSPECTION';
  kbycMinimalCertificateState.offerCode = offerCode;
  kbycMinimalCertificateState.ineligibleReasons = ineligibleReasons;
  kbycMinimalCertificateState.dealerId = prospect.dealerId;
  kbycMinimalCertificateState.displayType = displayType;
};

const setMinimalCertificateDisplayType = (displayType: MinimalCertificateDisplayType): void => {
  kbycMinimalCertificateState.displayType = displayType;
};

export const onViewOffer = (): void => {
  trackCertificateViewYourOffer(kbycMinimalCertificateState.isKelleyBuysYourCar);
  const certificateUrl = `${process.env.FURY_URL}/instant-cash-offer/offer/${kbycMinimalCertificateState.offerId}/?LNX=${pageParamsState.lnxCode}&dealerId=${KBYC_DEALER.GUID}`;
  window.open(certificateUrl, '_blank');
  EventBus.publish('onViewOffer', kbycMinimalCertificateState.offerId);
};

const actions = {
  onMinimalCertificateSet,
  setMinimalCertificateDisplayType,
};

export { actions };
export default { actions };
